import { render, staticRenderFns } from "./MaintainceQbr.vue?vue&type=template&id=c37ff01c&scoped=true"
import script from "./MaintainceQbr.vue?vue&type=script&lang=js"
export * from "./MaintainceQbr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37ff01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c37ff01c')) {
      api.createRecord('c37ff01c', component.options)
    } else {
      api.reload('c37ff01c', component.options)
    }
    module.hot.accept("./MaintainceQbr.vue?vue&type=template&id=c37ff01c&scoped=true", function () {
      api.rerender('c37ff01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QBR/MaintainceQbr.vue"
export default component.exports